import { Injectable } from "@angular/core";
import tippy from "tippy.js";

@Injectable({
    providedIn: "root"
})
export class TippyWrapperService {
    constructor() { }

    createPopover(target: Element, popoverContent: HTMLElement, options={}): TippyWrapperInstance {
        if (!target) {
            throw new Error('Target element for the popover is not defined');
        }
        return tippy(target, this.getTippyOptions(popoverContent, options));
    }

    private getTippyOptions(popoverContent: HTMLElement, options) {
        // see full documentation here: https://atomiks.github.io/tippyjs/v6/all-props/
        const tippyOptions = {
            content: popoverContent,
            allowHTML: true,
            trigger: "manual",
            interactive: true,
            theme: "light-border",
            animation: "scale",
            appendTo: document.body,
            ...options
        };
        return tippyOptions;
    }

    private getContentFinal(popoverContent: string) {
        return `${popoverContent}`;
    }

    showPopover(instance) {
        if (instance.popoverIsShown) {
            return;
        }
        instance.show();
        instance.popoverIsShown = true;
    }

    togglePopover(instance) {
        if (instance.popoverIsShown) {
            this.hidePopover(instance);
        } else {
            this.showPopover(instance);
        }
    }

    hidePopover(instance) {
        if (!instance.popoverIsShown) {
            return;
        }
        instance.hide();
        instance.popoverIsShown = false;
    }
}

export interface TippyWrapperInstance {
    popoverIsShown?: boolean;
    hide: () => void;
    show: () => void;
    destroy: () => void;
}
